import {
    ERROR_EMPTY_PRODUCTCODE,
    ERROR_MINIMUM_PRODUCTCODE,
    ERROR_EMPTY_PRODUCTNAME1,
    ERROR_EMPTY_PRODUCTCLASS,
    ERROR_CHAR_KANA,
    ERROR_INVALID_PRODUCTCODE
} from "../../../../utils/messages";
import { isNullOrEmpty, isWholeNumber } from "../../../../utils/common";
import { EMPTY_COUNT, REGEX_HALF_WIDTH } from "../../../../utils/constants";

function validate(payload) {

    let prompt = [];

    if (isNullOrEmpty(payload.productCode)) {
        prompt.push(ERROR_EMPTY_PRODUCTCODE);
    }else if(!isWholeNumber(payload.productCode)){
        prompt.push(ERROR_INVALID_PRODUCTCODE);
    }

    if (EMPTY_COUNT > payload.productCode) {
        prompt.push(ERROR_MINIMUM_PRODUCTCODE);
    }

    if (isNullOrEmpty(payload.productName1)) {
        prompt.push(ERROR_EMPTY_PRODUCTNAME1);
    }

    if (isNullOrEmpty(payload.productClassCode)) {
        prompt.push(ERROR_EMPTY_PRODUCTCLASS);
    }

    if(!isNullOrEmpty(payload.productKana) && !payload.productKana.match(REGEX_HALF_WIDTH)){
        prompt.push(ERROR_CHAR_KANA);
    }
    

    return prompt;
}


export {
    validate,
};